import { render, staticRenderFns } from "./NotificationListItem.vue?vue&type=template&id=1e9143ff&scoped=true"
import script from "./NotificationListItem.vue?vue&type=script&lang=js"
export * from "./NotificationListItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationListItem.vue?vue&type=style&index=0&id=1e9143ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9143ff",
  null
  
)

export default component.exports